import { render, staticRenderFns } from "./Lrjkz.vue?vue&type=template&id=668bb56a&scoped=true&"
import script from "./Lrjkz.vue?vue&type=script&lang=js&"
export * from "./Lrjkz.vue?vue&type=script&lang=js&"
import style0 from "./Lrjkz.vue?vue&type=style&index=0&id=668bb56a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668bb56a",
  null
  
)

export default component.exports